<template>
  <div>
    <p class="cnt toCapitalize">
      {{filterInfo.type}}
      <span class="colorPrimary f_medium">{{localinfo.length}}</span> /
      {{filterInfo.length}}
      <span class="colorGrey">({{`${locale.all} ${list.length}`}})</span>
    </p>
    <div class="localinfoList">
      <LocalInfoItem
        v-for="item in localinfo"
        :key="item.placeId"
        :locale="locale"
        :item="item" />
    </div>
  </div>
</template>

<script>
import LocalInfoItem from '@/components/LocalInfo/Item.vue'

export default {
  props: [
    'locale',
    'list'
  ],
  components: {
    LocalInfoItem
  },
  computed: {
    listView () {
      return this.$store.state.localinfo.listView
    },
    getFilter () {
      return this.$store.getters['localinfo/getFilter']
    },
    filterInfo () {
      const filterType = this.getFilter.type
      const listType = filterType === '' ? this.locale.all : this.locale[`localinfo_${filterType}`]
      const listLength = filterType === '' ? this.list.length
        : filterType === 'recommend' ? this.recommend.length : this.list.filter(x => x.siteType === filterType).length
      return {
        type: listType,
        length: listLength
      }
    },
    recommend () {
      return this.list.filter(x => x.recommend)
    },
    localinfo () {
      const type = this.getFilter.type
      const word = this.getFilter.word.toLowerCase()
      const recommended = this.listView.recommended
      const viewOption = this.listView
      // 공개 상태 필터
      function listState (arr) {
        return arr.filter(x => {
          const show = viewOption.show && x.visible
          const hide = viewOption.hide && !x.visible
          return show || hide
        })
      }
      // 등록 구분 필터
      function listProvide (arr) {
        return arr.filter(x => {
          const create = viewOption.create && x.createby
          const provide = viewOption.provide && typeof (x.createby) === 'undefined'
          return create || provide
        })
      }
      function listView (arr) {
        return listState(listProvide(arr))
      }
      // 상태 필터 후 전체 리스트 리턴
      // let list = this.list ? this.list : []
      let list = this.list ? listView(this.list) : []
      if (!!word && word.trim().length !== 0) {
        // 검색어
        list = list.filter(x => x.name.toLowerCase().includes(word))
      }
      if (type) {
        // 지역정보 타입
        if (type === 'recommend') {
          list = list.filter(x => x.recommend)
        } else {
          list = list.filter(x => x.siteType === type)
        }
      }
      if (recommended) {
        list = list.filter(x => x.recommend)
      }
      return list
    }
  }
}
</script>

<style lang="scss" scoped>
.cnt {
  margin-bottom: 0.5em;
  text-align: right;
}
.noData {
  padding: 120px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 64px;
    margin-bottom: 30px;
    background: url('~@/assets/img/ico_search.svg') 50% 50% / contain no-repeat;
    opacity: 0.2;
  }
}
</style>
